/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_SearchInputs */

const vi_product_search = /** @type {(inputs: Product_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm hàng hóa (F3)`)
};

/**

* @param {Product_SearchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_search = /** @type {((inputs?: Product_SearchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_SearchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_search(inputs)
});